export const requiredPronvinceCode = [
  "AR", 
  "AU",  
  "BR",   
  "CA", 
  "CL",   
  "CN", 
  "CO", 
  "CZ",   
  "DE",  
  "ES", 
  "HK",   
  "ID",   
  "IE", 
  "IN",  
  "IT",  
  "JP", 
  "KR",  
  "MX", 
  "MY",  
  "NL",  
  "PE", 
  "PH",   
  "PT",  
  "RO",
  "RU",
  "US",   
  "VE", 
  "ZA",
  ];
  